import script from "./PackageContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageContainer.vue?vue&type=script&setup=true&lang=ts"

import "./PackageContainer.vue?vue&type=style&index=0&id=c070277e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c070277e"]])

export default __exports__